import { envConfig } from "@/libs/env-config";
import { ICheckout } from "@/types/checkout";
import { getCommonHeaders, handleApiError } from "./common";
import { CartStorage } from "@/libs/cart-storage";
import { getAffiliateParams } from "@/AffiliateTracker/affiliate-tracker";

// Base URL
const CART_API_URL = envConfig.apiCartUrl;

// API Endpoint
const CART = "/checkout";

const getCartHeaders = () => {
  const headers = getCommonHeaders();

  const token = CartStorage.getCartToken();

  if (token) {
    headers.append("X-Cart-Token", token);
  }

  return headers;
};

export const createCheckoutApi = async (): Promise<ICheckout> => {
  try {
    // Use direct fetch with the cart API URL
    const url = new URL(`${CART_API_URL}${CART}`);

    const token = CartStorage.getCartToken();
    const checkoutId = CartStorage.getCheckoutId();

    // get affiliate params from session
    const affiliateData = await getAffiliateParams();

    const body: any = {
      cart_token: token,
      checkout_id: checkoutId,
    };

    if (affiliateData) {
      body.attributes = affiliateData;
    }

    const response = await fetch(url.toString(), {
      headers: getCartHeaders(),
      body: JSON.stringify(body),
      method: "POST",
    });

    const data = await response.json();

    // Save token from response to both cookie and localStorage
    if (data && data.id) {
      CartStorage.saveCheckoutId(data.id);
    }

    return data;
  } catch (error) {
    return handleApiError(error, "createCheckoutApi");
  }
};
